module.exports = __webpack_public_path__ + "assets/img/img-map-kanto-sp.426f3295.svg";